export default __webpack_public_path__ + "a483d119fabdb86f37e0434ceb4f4f1f.png";